import EditTagsForm from './EditTagsForm';

export default EditTagsForm;
